import { useContext, useEffect, useState } from "react";
import { getActiveLanguage } from "react-localize-redux";
import { useSelector } from "react-redux";

import { MainContext } from "@context";

const selectLanguage = (state) => ({
	currentLanguage: getActiveLanguage(state.localize).code,
});

const useController = () => {
	const {
		state: { isMobile, isTablet, isDesktop, isWide, isMinor },
	} = useContext(MainContext);

	const { currentLanguage } = useSelector(selectLanguage);

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	const getSlidesPerGroup = () => {
		if (isMinor) {
			return 1;
		} else if (isMobile) {
			return 2;
		} else if (isTablet) {
			return 3;
		} else if (isDesktop) {
			return 4;
		} else if (isWide) {
			return 5;
		} else {
			return 6;
		}
	};

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return {
		state: {
			windowWidth,
			slidesPerGroup: getSlidesPerGroup(),
			currentLanguage: currentLanguage || "en",
		},
	};
};

export default useController;
